import { AccountTransactionList } from "../tlSalesOnAccount";

const TLJournalVoucher = () => <AccountTransactionList
  title="Journal Voucher"
  moduleId="ACTJOV"
  storageKey="journalVoucher.filters"
  accessPath="/api/journal-voucher/access"
  statusPath="/api/journal-voucher/status"
  printPath="/api/journal-voucher/print"
  transactionPath="/App/JournalVoucherTransaction"
  linkProjectPath="/api/journal-voucher/assignment"
  documentPrefix="JV"
  rowClassPrefix="jv"
  moneyFields={["TotalDebit", "TotalCredit", "Debit", "Credit"]}
  filterByBranch={false}
  branchLabel="Working Branch"
  showListSearch
  centeredErrors
  hideUnauthorizedActions
/>;

export default TLJournalVoucher;
